import I18N from '@leverege/i18n';
import LayoutModel from "../../layout/LayoutModel.js";
const {
  t,
  tf,
  tIcon,
  tfIcon
} = I18N.ns('molten.dataViewers.table.AdvancedFilterAction');
export default {
  id: 'molten.dataViewers.table.AdvancedFilterAction',
  matches: {
    use: 'tableColumnHeaderActionBar',
    client: 'TableDataViewer'
  },
  layout: {
    sort: tf('sortValue'),
    group: [tf('filter')],
    groupIcons: [tfIcon('filterMenuIcon', 'fa fa-fw fa-chevron-down')]
  },
  handles: cxt => {
    const {
      clientProps: {
        layout
      }
    } = cxt;
    return cxt.canFilter && layout && LayoutModel.getShowFilterBar(layout);
  },
  appearance: ({
    context: cxt
  }) => {
    return {
      name: t('name'),
      icon: tIcon('advancedFilterActionIcon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      attribute: attr
    } = context;
    window.dispatchEvent(new CustomEvent(`molten.filter.${attr.objectType}.open`, {
      detail: {
        attrName: attr.name,
        objectType: attr.objectType
      }
    }));
  }
};